import { render } from "./ProjectSection.vue?vue&type=template&id=6b2940ba&ts=true"
import script from "./ProjectSection.vue?vue&type=script&lang=ts"
export * from "./ProjectSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__